import React, { useState } from "react";
import "./styles.css";
// import bg from "../../assets/videos/background.mp4";
import bg from "../../assets/videos/Website.mp4";

const BackgroundVideo = () => {
  const [isMuted, setIsMuted] = useState(false);

  const handleMuteUnmuteClick = () => {
    setIsMuted(!isMuted);
    const video = document.querySelector("video");
    video.muted = !isMuted;
  };

  const handleArrowClick = () => {
    window.scroll({
      top: (window.innerHeight * 3) / 4,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="video-container" style={{
         pointerEvents: 'none',  
          position: 'relative'
      }}>
        <video
          className="bg-video"
          src={bg}
          autoPlay
          loop
          muted={true}
          data-aos="zoom-in"
          playsInline
          controlsList="nodownload nofullscreen noremoteplayback"
          disablePictureInPicture
          style={{
            pointerEvents: 'none',  // Extra protection against interaction
            userSelect: 'none',     // Prevent text selection
            WebkitTouchCallout: 'none'
          }}
        ></video>
        <div className="BannerContainer">
          {/* <h2 className="BannerText" data-aos="fade-up" data-aos-delay="1000">Forever begins with us</h2> */}
        </div>
      </div>
    </>
  );
};

export default BackgroundVideo;
